import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
class Header extends Component {
	constructor(props) {
		super(props);

		this.state = {
			time: "00:00",
			nameErr: false,
		};
	}

	render() {
		return (
			<div>
				<Row className="topBar">
					{this.props.onClick && (
						<Button
							title="Go Back"
							type="button"
							className="backBtn ml-n1"
							onClick={this.props.onClick}
						>
							<FontAwesomeIcon icon={faChevronLeft} size="1x" />
						</Button>
					)}
					<div className="col-lg-8 col-md-8 col-sm-12 mr-auto mt-2 mt-md-0  title">
						{this.props.title}
					</div>
				</Row>
				{this.props.headerBorder ? null : <hr />}
			</div>
		);
	}
}
export default Header;
